/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, Card, Button, Modal, Form, Alert, Spinner, Badge, Accordion } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';

// Add CSS for booking link job flashing effect (same as AcceptedJobs)
const bookingLinkStyles = `
  .booking-link-job {
    animation: bookingLinkFlash 2s infinite;
    border: 2px solid #007bff !important;
  }
  
  @keyframes bookingLinkFlash {
    0%, 100% { 
      background-color: rgba(0, 123, 255, 0.1);
      box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
    }
    50% { 
      background-color: rgba(0, 123, 255, 0.2);
      box-shadow: 0 0 15px rgba(0, 123, 255, 0.5);
    }
  }
  
  /* Flashing chevron after booking link text */
  .booking-link-flash-arrow {
    display: inline-block;
    margin-left: 8px;
    animation: chevronFlash 0.8s infinite;
    font-size: 1.8rem;
    font-weight: bold;
    line-height: 1;
    vertical-align: middle;
    color: #FFD700 !important;
  }
  
  @keyframes chevronFlash {
    0%, 100% { 
      color: #FFD700 !important;
      opacity: 1;
      transform: scale(1);
      text-shadow: 0 0 5px rgba(255, 215, 0, 0.8), 0 0 10px rgba(255, 215, 0, 0.5);
    }
    50% { 
      color: #FFFF00 !important;
      opacity: 0.9;
      transform: scale(1.2);
      text-shadow: 0 0 10px rgba(255, 255, 0, 1), 0 0 20px rgba(255, 215, 0, 0.8);
    }
  }
  
  /* Force white text for booking link and wait & return headers */
  .booking-link-header {
    color: white !important;
  }
  
  .booking-link-header strong {
    color: white !important;
  }
  
  .wait-return-header {
    color: white !important;
  }
  
  .wait-return-header strong {
    color: white !important;
  }
  
  /* Override accordion header text colors specifically */
  .accordion-header .booking-link-header {
    color: white !important;
  }
  
  .accordion-header .booking-link-header strong {
    color: white !important;
  }
  
  .accordion-header .wait-return-header {
    color: white !important;
  }
  
  .accordion-header .wait-return-header strong {
    color: white !important;
  }
  
  /* More specific targeting for accordion header text */
  .accordion-button .booking-link-header,
  .accordion-button .wait-return-header {
    color: white !important;
  }
  
  .accordion-button .booking-link-header strong,
  .accordion-button .wait-return-header strong {
    color: white !important;
  }
  
  /* Ultra-specific targeting for Bootstrap accordion override */
  .accordion-item .accordion-header .accordion-button .booking-link-header,
  .accordion-item .accordion-header .accordion-button .wait-return-header {
    color: white !important;
  }
  
  .accordion-item .accordion-header .accordion-button .booking-link-header strong,
  .accordion-item .accordion-header .accordion-button .wait-return-header strong {
    color: white !important;
  }
  
  /* Target all text within these specific elements - but not chevrons */
  .booking-link-header *:not(.booking-link-flash-arrow),
  .wait-return-header *:not(.booking-link-flash-arrow) {
    color: white !important;
  }
  
  /* Ensure chevrons stay yellow */
  .booking-link-header .booking-link-flash-arrow,
  .wait-return-header .booking-link-flash-arrow {
    color: #FFD700 !important;
  }
`;

// Inject the styles
if (!document.getElementById('booking-link-styles')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'booking-link-styles';
  styleSheet.textContent = bookingLinkStyles;
  document.head.appendChild(styleSheet);
}

const DispatchModule = () => {
  const [drivers, setDrivers] = useState([]);
  const [driverJobs, setDriverJobs] = useState({});
  const [availableJobs, setAvailableJobs] = useState([]);
  const [diagnostics, setDiagnostics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPC, setIsPC] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showReassignModal, setShowReassignModal] = useState(null);
  const [showDispatchModal, setShowDispatchModal] = useState(null);
  
  // Date picker modals (same as Add to Diary)
  const [showDateModal, setShowDateModal] = useState(false);
  const [showCreateMonthModal, setShowCreateMonthModal] = useState(false);
  const [showCreateYearModal, setShowCreateYearModal] = useState(false);
  const [showCreateHourModal, setShowCreateHourModal] = useState(false);
  const [showCreateMinuteModal, setShowCreateMinuteModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [createForm, setCreateForm] = useState({
    customerName: '',
    customerEmail: 'NoReply@taxi-local.com',
    customerPhone: '',
    from: '',
    to: '',
    dateTime: new Date(),
    passengers: 1,
    notes: '',
    driverId: '',
    returnTrip: false,
    dog: false,
    disabled: false,
    waitAndReturn: false,
    waitHours: '',
    fareAmount: ''
  });
  const [dispatchForm, setDispatchForm] = useState({
    driverId: '',
    dispatchNote: ''
  });
  const [saving, setSaving] = useState(false);
  const [driverDiaries, setDriverDiaries] = useState({});
  const [loadingDiaries, setLoadingDiaries] = useState({});

  // PC Detection and User Role
  useEffect(() => {
    const checkIsPC = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
      const isTablet = /ipad|android(?!.*mobile)/i.test(userAgent);
      setIsPC(!isMobile && !isTablet);
    };
    
    // Get user role
    const role = localStorage.getItem('role');
    setUserRole(role);
    
    checkIsPC();
    window.addEventListener('resize', checkIsPC);
    return () => window.removeEventListener('resize', checkIsPC);
  }, []);

  // Fetch drivers and their jobs
  // Fetch driver diary
  const fetchDriverDiary = useCallback(async (driverId) => {
    try {
      setLoadingDiaries(prev => ({ ...prev, [driverId]: true }));
      const token = localStorage.getItem('token');
      const response = await axios.get(`/view-leads/driver-diary/${driverId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDriverDiaries(prev => ({ ...prev, [driverId]: response.data }));
    } catch (error) {
      console.error('Error fetching driver diary:', error);
      toast.error('Failed to load driver diary');
    } finally {
      setLoadingDiaries(prev => ({ ...prev, [driverId]: false }));
    }
  }, []);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      
      // Fetch dispatch data (drivers and their jobs)
      const dispatchResponse = await axios.get('/view-leads/dispatch-data', {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Fetch available jobs for dispatch
      const availableResponse = await axios.get('/view-leads/available-jobs-for-dispatch', {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setDrivers(dispatchResponse.data.drivers);
      setDriverJobs(dispatchResponse.data.jobs);
      setAvailableJobs(availableResponse.data.availableJobs);
      setDiagnostics(dispatchResponse.data.diagnostics);

      // Fetch diaries for all drivers
      const driverIds = dispatchResponse.data.drivers.map(driver => driver._id);
      for (const driverId of driverIds) {
        await fetchDriverDiary(driverId);
      }
    } catch (error) {
      console.error('Error fetching dispatch data:', error);
      toast.error('Failed to load dispatch data');
    } finally {
      setLoading(false);
    }
  }, [fetchDriverDiary]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Helper functions for diary formatting (exact same as AcceptedJobs)
  const formatWhen = (iso) => {
    try {
      const date = new Date(iso);
      if (isNaN(date.getTime())) {
        console.warn('Invalid date in formatWhen:', iso);
        return 'Invalid Date';
      }
      const parts = new Intl.DateTimeFormat('en-GB', {
        hour: 'numeric', minute: '2-digit', hour12: true,
        weekday: 'short', day: 'numeric', month: 'short',
        timeZone: 'Europe/London'
      }).formatToParts(date);
      const p = Object.fromEntries(parts.map(x => [x.type, x.value]));
      return `${p.hour}:${p.minute} ${p.dayPeriod?.toLowerCase()}, ${p.weekday} ${p.day} ${p.month}`;
    } catch (error) {
      console.warn('Error formatting date:', iso, error);
      return 'Invalid Date';
    }
  };

  const extractTowns = (from, to) => {
    const fromTown = from.split(',')[0].trim();
    const toTown = to.split(',')[0].trim();
    return `${fromTown} → ${toTown}`;
  };

  // Helper functions for date handling (same as AcceptedJobs)
  const toISOStringLocal = (date) => {
    const tzoffset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - tzoffset).toISOString();
  };

  const createSafeDate = (dateString) => {
    try {
      return new Date(dateString);
    } catch (error) {
      console.warn('Error creating date:', error);
      return new Date();
    }
  };

  const calculateReturnTime = (dateTime, waitHours) => {
    if (!dateTime || !waitHours) return '';
    const returnTime = new Date(dateTime.getTime() + (waitHours * 60 * 60 * 1000));
    return returnTime.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true });
  };

  // Group jobs by time periods (same logic as AcceptedJobs)
  const groupJobsByTime = (jobs) => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    
    // Get start of next week (Monday)
    const startOfNextWeek = new Date(today);
    const daysUntilMonday = (1 - today.getDay() + 7) % 7;
    startOfNextWeek.setDate(today.getDate() + (daysUntilMonday === 0 ? 7 : daysUntilMonday));
    
    // Check if tomorrow is Monday
    const isTomorrowMonday = tomorrow.getDay() === 1;

    const yesterdayJobs = jobs.filter(j => {
      try {
        const jobDate = new Date(j.dateTime);
        const jobDateOnly = new Date(jobDate.getFullYear(), jobDate.getMonth(), jobDate.getDate());
        return jobDateOnly.getTime() === yesterday.getTime();
      } catch (e) {
        return false;
      }
    });
    
    const todayJobs = jobs.filter(j => {
      try {
        const jobDate = new Date(j.dateTime);
        const jobDateOnly = new Date(jobDate.getFullYear(), jobDate.getMonth(), jobDate.getDate());
        return jobDateOnly.getTime() === today.getTime();
      } catch (e) {
        return false;
      }
    });
    
    const tomorrowJobs = jobs.filter(j => {
      try {
        const jobDate = new Date(j.dateTime);
        const jobDateOnly = new Date(jobDate.getFullYear(), jobDate.getMonth(), jobDate.getDate());
        return jobDateOnly.getTime() === tomorrow.getTime();
      } catch (e) {
        return false;
      }
    });
    
    const restOfWeekJobs = jobs.filter(j => {
      try {
        const jobDate = new Date(j.dateTime);
        const jobDateOnly = new Date(jobDate.getFullYear(), jobDate.getMonth(), jobDate.getDate());
        return jobDateOnly > tomorrow && jobDateOnly < startOfNextWeek;
      } catch (e) {
        return false;
      }
    });
    
    const nextWeekJobs = jobs.filter(j => {
      try {
        const jobDate = new Date(j.dateTime);
        const jobDateOnly = new Date(jobDate.getFullYear(), jobDate.getMonth(), jobDate.getDate());
        return jobDateOnly >= startOfNextWeek;
      } catch (e) {
        return false;
      }
    });
    
    const futureJobs = jobs.filter(j => {
      try {
        const jobDate = new Date(j.dateTime);
        const jobDateOnly = new Date(jobDate.getFullYear(), jobDate.getMonth(), jobDate.getDate());
        const endOfNextWeek = new Date(startOfNextWeek);
        endOfNextWeek.setDate(startOfNextWeek.getDate() + 7);
        return jobDateOnly >= endOfNextWeek;
      } catch (e) {
        return false;
      }
    });

    // If tomorrow is Monday, move tomorrow's jobs to next week
    const finalTomorrowJobs = isTomorrowMonday ? [] : tomorrowJobs;
    const finalNextWeekJobs = isTomorrowMonday ? [...nextWeekJobs, ...tomorrowJobs] : nextWeekJobs;

    return {
      yesterdayJobs,
      todayJobs,
      finalTomorrowJobs,
      restOfWeekJobs,
      finalNextWeekJobs,
      futureJobs,
      startOfNextWeek
    };
  };

  // Render available job as accordion card
  const renderAvailableJobAccordion = (j, idx) => {
    return (
      <div key={j._id} style={{ position: 'relative', zIndex: 1 }}>
        <Accordion alwaysOpen={false} className="mb-2">
          <Accordion.Item eventKey={String(idx)} className="border-warning">
            <Accordion.Header>
              <div className="d-flex flex-column w-100">
                {/* Available for Dispatch header - Yellow background */}
                <div className="bg-warning text-dark mb-0 rounded-top" style={{ marginTop: '-17px', marginLeft: '-21px', marginRight: '-42px', padding: '0.015rem' }}>
                  <strong style={{ fontSize: '0.7rem' }}>🚛 Available for Dispatch</strong>
                </div>
                
                <div className="d-flex align-items-center gap-2">
                  <strong>{formatWhen(j.dateTime)}</strong>
                  <Badge bg="warning">Pending</Badge>
                </div>
                <small>{extractTowns(j.from, j.to)}</small>
              </div>
            </Accordion.Header>
            <Accordion.Body style={{ 
              position: 'absolute', 
              top: '100%', 
              left: 0, 
              right: 0, 
              zIndex: 10, 
              backgroundColor: 'white', 
              border: '1px solid #ffc107', 
              borderTop: 'none',
              borderRadius: '0 0 0.375rem 0.375rem',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              maxHeight: '400px',
              overflowY: 'auto'
            }}>
            <p><strong>Customer:</strong> {j.customerName?.split(' ')[0] || j.customerName}</p>
            <p><strong>Route:</strong> {j.from} → {j.to}</p>
            <p><strong>Phone:</strong> {j.customerPhone}</p>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <p><strong>Passengers:</strong> {j.passengers}</p>
                {j.returnTrip && <p><strong>Return Trip:</strong> Yes</p>}
                {j.dog && <p><strong>Dog:</strong> Yes</p>}
                {j.disabled && <p><strong>Disabled Access:</strong> Yes</p>}
                {j.notes && <p><strong>Notes:</strong> {j.notes}</p>}
              </div>
            </div>
            
            {/* Action Buttons - Same as Driver My Diary */}
            <div className="d-flex flex-column gap-2 mt-3 w-100">
              {/* Row 1: Dispatch Button */}
              <div className="d-flex gap-2 w-100">
                <Button
                  variant="success"
                  size="md"
                  className="flex-fill"
                  onClick={() => handleDispatchJob(j)}
                  title="Dispatch Job"
                >
                  🚛 Dispatch
                </Button>
              </div>

              {/* Row 2: Edit, Return Buttons */}
              <div className="d-flex gap-2 w-100">
                <Button 
                  variant="secondary" 
                  size="md" 
                  className="flex-fill"
                  onClick={() => handleEditJob(j)}
                >
                  ✏️ Edit
                </Button>
                <Button 
                  variant="info" 
                  size="md" 
                  className="flex-fill"
                  onClick={() => handleCreateReturnTrip(j)}
                >
                  🔄 Return
                </Button>
              </div>

              {/* Row 3: Cancel, Re-assign */}
              <div className="d-flex gap-2 w-100">
                <Button 
                  variant="danger" 
                  size="md" 
                  className="flex-fill"
                  onClick={() => handleCancelJob(j)}
                >
                  ❌ Cancel
                </Button>
                <Button 
                  variant="warning" 
                  size="md" 
                  className="flex-fill"
                  onClick={() => handleReassignAvailableJob(j)}
                >
                  🔄 Re-assign
                </Button>
              </div>

              {/* Row 4: +Tomorrow, +Next Week, +Next Month */}
              <div className="d-flex gap-2 w-100">
                <Button 
                  size="sm" 
                  variant="outline-secondary" 
                  className="flex-fill" 
                  onClick={() => handleDuplicateJob(j, 1)}
                >
                  +Tomorrow
                </Button>
                <Button 
                  size="sm" 
                  variant="outline-secondary" 
                  className="flex-fill" 
                  onClick={() => handleDuplicateJob(j, 7)}
                >
                  +Next Week
                </Button>
                <Button 
                  size="sm" 
                  variant="outline-secondary" 
                  className="flex-fill" 
                  onClick={() => handleDuplicateJob(j, 30)}
                >
                  +Next Month
                </Button>
              </div>
            </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    );
  };

  // Render job item in accordion format (same as AcceptedJobs)
  const renderJobItem = (j, idx) => {
    const isWebLinkJob = !j.bookingLinkId && !j.createdByDispatcher && !j.isManualDiaryEntry;
    const isWebLinkPendingReview = isWebLinkJob && (!j.status || j.status === 'pending');
    return (
      <Accordion.Item 
        eventKey={String(idx)} 
        key={j._id}
        className=""
      >
        <Accordion.Header>
          <div className="d-flex flex-column w-100">
            {/* Booking Link header - Red when pending, Blue when accepted */}
            {j.bookingLinkId && (
              <div className={`${!j.acceptedAt ? 'bg-danger' : 'bg-primary'} mb-0 rounded-top booking-link-header`} style={{ marginTop: '-17px', marginLeft: '-21px', marginRight: '-42px', padding: '0.3rem 0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <strong style={{ fontSize: '0.7rem', color: 'white', display: 'flex', alignItems: 'center' }}>
                  🔗 Booking Link {!j.acceptedAt ? '(Action Required)' : '(Accepted)'}
                  {!j.acceptedAt && <span className="booking-link-flash-arrow">««««</span>}
                </strong>
              </div>
            )}
            
            {/* Web-Link header - Green background for web bookings from Fare Calculator */}
            {isWebLinkJob && (
              <div className="bg-success text-white mb-0 rounded-top" style={{ marginTop: '-17px', marginLeft: '-21px', marginRight: '-42px', padding: '0.3rem 0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <strong style={{ fontSize: '0.7rem', color: 'white', display: 'flex', alignItems: 'center' }}>
                  🔗 Web-Link {isWebLinkPendingReview ? '(Action Required)' : '(Accepted)'}
                  {isWebLinkPendingReview && <span className="booking-link-flash-arrow">««««</span>}
                </strong>
              </div>
            )}
            
            {/* Dispatched Job header - Yellow background */}
            {j.createdByDispatcher && (
              <div className="bg-warning text-dark mb-0 rounded-top" style={{ marginTop: '-17px', marginLeft: '-21px', marginRight: '-42px', padding: '0.015rem' }}>
                <strong style={{ fontSize: '0.7rem' }}>🚛 Dispatched Job</strong>
              </div>
            )}
            
            <div className="d-flex align-items-center gap-2">
              <strong>{formatWhen(j.dateTime)}</strong>
              {j.status === 'confirmed' && (
                <span className="badge bg-success" title="Confirmed with customer">
                  ✅ Confirmed
                </span>
              )}
            </div>
            <small>{extractTowns(j.from, j.to)}</small>
            
            {/* Wait and Return footer - Show at bottom of accordion header */}
            {j.waitAndReturn && j.waitHours && (
              <div className="bg-success text-white mt-2 rounded-bottom" style={{ marginLeft: '-21px', marginRight: '-42px', marginBottom: '-17px', padding: '0.015rem', textAlign: 'right' }}>
                <strong style={{ fontSize: '0.7rem' }}>
                  ⏰ Wait & Return - {new Date(new Date(j.dateTime).getTime() + (j.waitHours * 60 * 60 * 1000)).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true })}
                </strong>
              </div>
            )}
          </div>
        </Accordion.Header>
        <Accordion.Body>
          <p><strong>Customer:</strong> {j.customerName?.split(' ')[0] || j.customerName}</p>
          <p><strong>Route:</strong> {j.from} → {j.to}</p>
          {j.mileage && <p><strong>Distance:</strong> {j.mileage} miles</p>}
          {j.duration && <p><strong>Duration:</strong> {j.duration} minutes</p>}
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <p><strong>Passengers:</strong> {j.passengers}</p>
              {j.returnTrip && <p><strong>Return Trip:</strong> Yes</p>}
              {j.dog && <p><strong>Dog:</strong> Yes</p>}
              {j.disabled && <p><strong>Disabled Access:</strong> Yes</p>}
              {j.notes && <p><strong>Notes:</strong> {j.notes}</p>}
            </div>
            <div className="text-end">
              <Badge bg={
                j.status === 'completed' ? 'success' :
                j.status === 'accepted' ? 'primary' :
                j.status === 'pending' ? 'warning' :
                j.status === 'cancelled' ? 'danger' : 'secondary'
              }>
                {j.status}
              </Badge>
            </div>
          </div>
          
          {/* Action Buttons - Same as Driver My Diary */}
          <div className="d-flex flex-column gap-2 mt-3 w-100">
            {/* Row 1: Complete Button */}
            <div className="d-flex gap-2 w-100">
              <Button 
                variant="success" 
                size="md" 
                className="flex-fill"
                onClick={() => handleCompleteJob(j)}
                disabled={j.status === 'completed'}
              >
                ✅ Complete
              </Button>
            </div>

            {/* Row 2: Edit, Return Buttons */}
            <div className="d-flex gap-2 w-100">
              <Button 
                variant="secondary" 
                size="md" 
                className="flex-fill"
                onClick={() => handleEditJob(j)}
              >
                ✏️ Edit
              </Button>
              <Button 
                variant="info" 
                size="md" 
                className="flex-fill"
                onClick={() => handleCreateReturnTrip(j)}
              >
                🔄 Return
              </Button>
            </div>

            {/* Row 3: Cancel, Re-assign */}
            <div className="d-flex gap-2 w-100">
              <Button 
                variant="danger" 
                size="md" 
                className="flex-fill"
                onClick={() => handleCancelJob(j)}
                disabled={j.status === 'cancelled'}
              >
                ❌ Cancel
              </Button>
              <Button 
                variant="warning" 
                size="md" 
                className="flex-fill"
                onClick={() => {
                  // Find the current driver ID for this job
                  const currentDriverId = Object.keys(driverDiaries).find(driverId => 
                    driverDiaries[driverId]?.some(job => job._id === j._id)
                  );
                  if (currentDriverId) {
                    setShowReassignModal({ job: j, fromDriverId: currentDriverId });
                  }
                }}
                title="Re-assign Job"
              >
                🔄 Re-assign
              </Button>
            </div>

            {/* Row 4: +Tomorrow, +Next Week, +Next Month */}
            <div className="d-flex gap-2 w-100">
              <Button 
                size="sm" 
                variant="outline-secondary" 
                className="flex-fill" 
                onClick={() => handleDuplicateJob(j, 1)}
              >
                +Tomorrow
              </Button>
              <Button 
                size="sm" 
                variant="outline-secondary" 
                className="flex-fill" 
                onClick={() => handleDuplicateJob(j, 7)}
              >
                +Next Week
              </Button>
              <Button 
                size="sm" 
                variant="outline-secondary" 
                className="flex-fill" 
                onClick={() => handleDuplicateJob(j, 30)}
              >
                +Next Month
              </Button>
            </div>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    );
  };

  // Handle job reassignment
  const handleReassignJob = async (jobId, fromDriverId, toDriverId) => {
    console.log('handleReassignJob called with:', { jobId, fromDriverId, toDriverId });
    
    if (fromDriverId === toDriverId) {
      toast.warning('Cannot reassign job to the same driver');
      return;
    }

    if (!jobId || !fromDriverId || !toDriverId) {
      console.error('Missing required parameters:', { jobId, fromDriverId, toDriverId });
      toast.error('Missing required parameters for job reassignment');
      return;
    }

    try {
      setSaving(true);
      const token = localStorage.getItem('token');
      
      if (!token) {
        throw new Error('Authentication token not found');
      }
      
      // Get user ID from localStorage (userId is stored separately)
      const userId = localStorage.getItem('userId');
      if (!userId) {
        throw new Error('User ID not found');
      }

      console.log('Making reassign API call:', {
        jobId,
        reassignedTo: toDriverId,
        reassignedBy: userId
      });
      
      await axios.patch(`/view-leads/reassign-job/${jobId}`, {
        reassignedTo: toDriverId,
        reassignedBy: userId
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Update local state
      const job = driverJobs[fromDriverId]?.find(j => j._id === jobId);
      if (job) {
        setDriverJobs(prev => ({
          ...prev,
          [fromDriverId]: prev[fromDriverId]?.filter(j => j._id !== jobId) || [],
          [toDriverId]: [...(prev[toDriverId] || []), { ...job, reassignedTo: toDriverId }]
        }));
      } else {
        console.warn('Job not found in local state for reassignment:', { jobId, fromDriverId });
      }

      toast.success('Job reassigned successfully');
      
      // Refresh driver diaries to show updated job assignments
      const driverIds = Object.keys(driverDiaries);
      for (const driverId of driverIds) {
        await fetchDriverDiary(driverId);
      }
    } catch (error) {
      console.error('Error reassigning job:', error);
      toast.error('Failed to reassign job');
    } finally {
      setSaving(false);
    }
  };

  // Format timestamp
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${hours}:${minutes}-${day}/${month}/${year}`;
  };

  // Show job timestamps
  const showJobTimestamps = (job) => {
    const timestamps = [
      { label: 'Created', value: job.createdAt },
      { label: 'Modified', value: job.updatedAt },
      { label: 'Accepted', value: job.acceptedAt },
      { label: 'Completed', value: job.completedAt }
    ].filter(ts => ts.value);

    const message = timestamps.map(ts => 
      `${ts.label}: ${formatTimestamp(ts.value)}`
    ).join('\n');

    toast.info(message, { autoClose: 5000 });
  };

  // Handle edit job
  const handleEditJob = (job, driverId) => {
    setSelectedJob(job);
    setSelectedDriver(driverId);
    setEditForm({
      customerName: job.customerName || '',
      phone: job.phone || '',
      from: job.from || '',
      to: job.to || '',
      dateTime: job.dateTime ? new Date(job.dateTime).toISOString().slice(0, 16) : '',
      passengers: job.passengers || 1,
      notes: job.notes || ''
    });
    setShowEditModal(true);
  };


  // Handle dispatch job
  const handleDispatchJob = (job) => {
    setSelectedJob(job);
    setDispatchForm({ driverId: '', dispatchNote: '' });
    setShowDispatchModal(true);
  };

  // Handle create form changes (same as Add to Diary)
  const handleCreateFormChange = (e) => {
    const { name, value, checked, type } = e.target;
    setCreateForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  // Handler functions for job actions (same as Driver My Diary)
  const handleCompleteJob = async (job) => {
    try {
      setSaving(true);
      await axios.patch(`/view-leads/${job._id}`, {
        status: 'completed',
        completedAt: new Date().toISOString()
      });
      toast.success('Job marked as completed');
      fetchData(); // Refresh all data
    } catch (error) {
      console.error('Error completing job:', error);
      toast.error('Failed to complete job');
    } finally {
      setSaving(false);
    }
  };

  const handleCancelJob = async (job) => {
    try {
      setSaving(true);
      await axios.patch(`/view-leads/${job._id}`, {
        status: 'cancelled',
        cancelledAt: new Date().toISOString()
      });
      toast.success('Job cancelled');
      fetchData(); // Refresh all data
    } catch (error) {
      console.error('Error cancelling job:', error);
      toast.error('Failed to cancel job');
    } finally {
      setSaving(false);
    }
  };

  const handleCreateReturnTrip = (job) => {
    // Set up return trip form with reversed route
    setCreateForm({
      customerName: job.customerName,
      customerEmail: job.customerEmail || 'NoReply@taxi-local.com',
      customerPhone: job.customerPhone,
      from: job.to, // Reverse the route
      to: job.from,
      dateTime: new Date(new Date(job.dateTime).getTime() + (job.waitHours ? job.waitHours * 60 * 60 * 1000 : 2 * 60 * 60 * 1000)), // Add wait time or 2 hours
      passengers: job.passengers,
      returnTrip: false, // This is the return trip
      dog: job.dog,
      disabled: job.disabled,
      waitAndReturn: false,
      waitHours: '',
      notes: `Return trip for ${job.customerName}`,
      driverId: job.acceptedBy || '', // Assign to same driver if available
      fareAmount: job.fareAmount || ''
    });
    setShowCreateModal(true);
  };

  const handleReassignAvailableJob = (job) => {
    // For available jobs, we can reassign to any driver
    setShowReassignModal({ job, fromDriverId: null });
  };

  const handleDuplicateJob = (job, daysToAdd) => {
    try {
      const baseDate = new Date(job.dateTime);
      const newDate = new Date(baseDate.getTime() + (daysToAdd * 24 * 60 * 60 * 1000));
      
      setCreateForm({
        customerName: job.customerName,
        customerEmail: job.customerEmail || 'NoReply@taxi-local.com',
        customerPhone: job.customerPhone,
        from: job.from,
        to: job.to,
        dateTime: newDate,
        passengers: job.passengers,
        returnTrip: job.returnTrip,
        dog: job.dog,
        disabled: job.disabled,
        waitAndReturn: job.waitAndReturn,
        waitHours: job.waitHours || '',
        notes: job.notes || '',
        driverId: '', // Don't auto-assign
        fareAmount: job.fareAmount || ''
      });
      setShowCreateModal(true);
      toast.success(`Job duplicated for ${daysToAdd === 1 ? 'tomorrow' : daysToAdd === 7 ? 'next week' : 'next month'}`);
    } catch (error) {
      console.error('Error duplicating job:', error);
      toast.error('Failed to duplicate job');
    }
  };

  // Save dispatch
  const handleSaveDispatch = async () => {
    if (!dispatchForm.driverId) {
      toast.error('Please select a driver');
      return;
    }

    try {
      setSaving(true);
      const token = localStorage.getItem('token');
      
      await axios.post('/view-leads/dispatch-job', {
        jobId: selectedJob._id,
        driverId: dispatchForm.driverId,
        dispatchNote: dispatchForm.dispatchNote
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Update local state
      setAvailableJobs(prev => prev ? prev.filter(job => job._id !== selectedJob._id) : []);
      setDriverJobs(prev => ({
        ...prev,
        [dispatchForm.driverId]: [...(prev[dispatchForm.driverId] || []), { ...selectedJob, acceptedBy: dispatchForm.driverId }]
      }));

      setShowDispatchModal(false);
      toast.success('Job dispatched successfully');
    } catch (error) {
      console.error('Error dispatching job:', error);
      toast.error('Failed to dispatch job');
    } finally {
      setSaving(false);
    }
  };

  // Save edit
  const handleSaveEdit = async () => {
    try {
      setSaving(true);
      const token = localStorage.getItem('token');
      
      await axios.patch(`/api/view-leads/${selectedJob._id}`, editForm, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Update local state
      setDriverJobs(prev => ({
        ...prev,
        [selectedDriver]: prev[selectedDriver].map(job => 
          job._id === selectedJob._id ? { ...job, ...editForm } : job
        )
      }));

      setShowEditModal(false);
      toast.success('Job updated successfully');
    } catch (error) {
      console.error('Error updating job:', error);
      toast.error('Failed to update job');
    } finally {
      setSaving(false);
    }
  };

  // Save create (same as Add to Diary)
  const handleSaveCreate = async (e) => {
    e.preventDefault();
    if (!createForm.customerPhone || createForm.customerPhone.trim() === '') {
      toast.error('Enter a valid phone number.');
      return;
    }
    
    const iso = toISOStringLocal(createForm.dateTime);
    try {
      if (createSafeDate(iso) < createSafeDate(new Date())) {
        toast.error('Date must be in the future.');
        return;
      }
    } catch (error) {
      console.warn('Error validating date:', error);
      toast.error('Invalid date format.');
      return;
    }

    try {
      setSaving(true);
      const token = localStorage.getItem('token');
      
      // First create the job using admin endpoint
      console.log('Making API call to:', axios.defaults.baseURL + '/admin/leads');
      const createResponse = await axios.post('/admin/leads', {
        customerName: createForm.customerName,
        customerEmail: createForm.customerEmail,
        customerPhone: createForm.customerPhone,
        from: createForm.from,
        to: createForm.to,
        dateTime: iso,
        passengers: createForm.passengers,
        returnTrip: createForm.returnTrip,
        dog: createForm.dog,
        disabled: createForm.disabled,
        waitAndReturn: createForm.waitAndReturn,
        waitHours: createForm.waitHours,
        notes: createForm.notes,
        status: 'pending'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (createForm.driverId) {
        // If a driver is selected, dispatch the job to them
        await axios.post('/view-leads/dispatch-job', {
          jobId: createResponse.data._id,
          driverId: createForm.driverId,
          dispatchNote: 'Created and dispatched by dispatch module'
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });

        // Update local state
        setDriverJobs(prev => ({
          ...prev,
          [createForm.driverId]: [...(prev[createForm.driverId] || []), { ...createResponse.data, acceptedBy: createForm.driverId }]
        }));
      } else {
        // Add to available jobs
        setAvailableJobs(prev => [...(prev || []), createResponse.data]);
      }

      setShowCreateModal(false);
      setCreateForm({
        customerName: '',
        customerEmail: 'NoReply@taxi-local.com',
        customerPhone: '',
        from: '',
        to: '',
        dateTime: new Date(),
        passengers: 1,
        notes: '',
        driverId: '',
        returnTrip: false,
        dog: false,
        disabled: false,
        waitAndReturn: false,
        waitHours: '',
        fareAmount: ''
      });
      toast.success('Job created successfully');
    } catch (error) {
      console.error('Error creating job:', error);
      toast.error('Failed to create job');
    } finally {
      setSaving(false);
    }
  };


  // Render driver column
  const renderDriverColumn = (driver) => (
    <Col key={driver._id} md={4} className="mb-4">
      <Card className="h-100">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <div>
            <h6 className="mb-0">{driver.companyName || driver.name}</h6>
            <small className="text-muted">{driver.email}</small>
            {driver.fleetName && (
              <div>
                <Badge bg="primary" className="mt-1">{driver.fleetName}</Badge>
              </div>
            )}
          </div>
          <div className="d-flex gap-1">
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => fetchDriverDiary(driver._id)}
              disabled={loadingDiaries[driver._id]}
              title="Refresh Diary"
            >
              {loadingDiaries[driver._id] ? <Spinner size="sm" /> : '🔄'}
            </Button>
          </div>
        </Card.Header>
        {driver.dispatcherNotes && (
          <Card.Header className="py-2 bg-light">
            <small className="text-muted">
              <strong>Notes:</strong> {driver.dispatcherNotes}
            </small>
          </Card.Header>
        )}
        <Card.Body className="p-2" style={{ minHeight: '400px' }}>
          {/* Driver Diary Section - Exact same format as AcceptedJobs */}
          <div className="mb-3">
            <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
              {driverDiaries[driver._id]?.length > 0 ? (
                (() => {
                  const jobs = driverDiaries[driver._id];
                  const groupedJobs = groupJobsByTime(jobs);
                  const {
                    yesterdayJobs,
                    todayJobs,
                    finalTomorrowJobs,
                    restOfWeekJobs,
                    finalNextWeekJobs,
                    futureJobs,
                    startOfNextWeek
                  } = groupedJobs;

                  return (
                    <>
                      {!!yesterdayJobs.length && <>
                        <h6 className="bg-dark text-warning text-center" style={{ marginTop: '20px' }}>Yesterday</h6>
                        <Accordion alwaysOpen={false}>
                          {yesterdayJobs.map(renderJobItem)}
                        </Accordion>
                      </>}
                      {!!todayJobs.length && <>
                        <h6 className="bg-dark text-warning text-center">Today</h6>
                        <Accordion alwaysOpen={false}>
                          {todayJobs.map(renderJobItem)}
                        </Accordion>
                      </>}
                      {!!finalTomorrowJobs.length && <>
                        <h6 className="bg-dark text-warning text-center">Tomorrow</h6>
                        <Accordion alwaysOpen={false}>
                          {finalTomorrowJobs.map(renderJobItem)}
                        </Accordion>
                      </>}
                      {!!restOfWeekJobs.length && <>
                        <h6 className="bg-dark text-warning text-center">Rest of week to Sunday</h6>
                        <Accordion alwaysOpen={false}>
                          {restOfWeekJobs.map(renderJobItem)}
                        </Accordion>
                      </>}
                      {!!finalNextWeekJobs.length && <>
                        <h6 className="bg-dark text-warning text-center">Next Week From Monday({startOfNextWeek.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' })})</h6>
                        <Accordion alwaysOpen={false}>
                          {finalNextWeekJobs.map(renderJobItem)}
                        </Accordion>
                      </>}
                      {!!futureJobs.length && <>
                        <h6 className="bg-dark text-warning text-center">Future Bookings</h6>
                        <Accordion alwaysOpen={false}>
                          {futureJobs.map(renderJobItem)}
                        </Accordion>
                      </>}
                    </>
                  );
                })()
              ) : (
                <div className="text-center text-muted py-3">
                  <div>No diary entries</div>
                  <small>Driver's schedule will appear here</small>
                </div>
              )}
            </div>
          </div>

        </Card.Body>
      </Card>
    </Col>
  );

  if (!isPC) {
    return (
      <Container className="mt-4">
        <Alert variant="warning" className="text-center">
          <h4>🖥️ PC Only Feature</h4>
          <p>The Dispatch Module is only available on desktop computers.</p>
          <p>Please access this feature from a PC or laptop.</p>
        </Alert>
      </Container>
    );
  }

  if (loading) {
    return (
      <Container className="mt-4 text-center">
        <Spinner animation="border" />
        <div>Loading dispatch data...</div>
      </Container>
    );
  }

  return (
    <Container fluid className="mt-4">
      <Row>
        <Col>
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div>
              <h4 className="mb-0">🚛 Dispatch Module</h4>
              <small className="text-muted">Click 🔄 to reassign jobs • Click ➕ to add jobs • Click ✏️ to edit</small>
              </div>
              <Button
                variant="primary"
                onClick={() => {
                  setCreateForm({
                    customerName: '',
                    phone: '',
                    from: '',
                    to: '',
                    dateTime: new Date().toISOString().slice(0, 16),
                    passengers: 1,
                    notes: '',
                    driverId: ''
                  });
                  setShowCreateModal(true);
                }}
                title="Create New Job"
              >
                ➕ Create Job
              </Button>
            </Card.Header>
            
            
            <Card.Body>
              {/* Available Jobs Section */}
              {availableJobs && availableJobs.length > 0 && (
                <Row className="mb-4">
                  <Col>
                    <Card className="border-warning">
                      <Card.Header className="bg-warning text-dark">
                        <h5 className="mb-0">
                          Available Jobs for Dispatch
                          <Badge bg="light" text="dark" className="ms-2">
                            {availableJobs ? availableJobs.length : 0}
                          </Badge>
                        </h5>
            </Card.Header>
                      <Card.Body>
                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                          {(() => {
                            const jobs = availableJobs;
                            const groupedJobs = groupJobsByTime(jobs);
                            const {
                              yesterdayJobs,
                              todayJobs,
                              finalTomorrowJobs,
                              restOfWeekJobs,
                              finalNextWeekJobs,
                              futureJobs,
                              startOfNextWeek
                            } = groupedJobs;

                            return (
                              <div>
                                {!!yesterdayJobs.length && (
                                  <div className="mb-3">
                                    <h6 className="bg-dark text-warning text-center mb-2">Yesterday</h6>
                                    <div className="d-flex flex-wrap gap-2">
                                      {yesterdayJobs.map((job, idx) => (
                                        <div key={job._id} style={{ minWidth: '300px', flex: '1 1 300px', maxWidth: '400px', position: 'relative', zIndex: 1 }}>
                                          {renderAvailableJobAccordion(job, idx)}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                                
                                {!!todayJobs.length && (
                                  <div className="mb-3">
                                    <h6 className="bg-dark text-warning text-center mb-2">Today</h6>
                                    <div className="d-flex flex-wrap gap-2">
                                      {todayJobs.map((job, idx) => (
                                        <div key={job._id} style={{ minWidth: '300px', flex: '1 1 300px', maxWidth: '400px', position: 'relative', zIndex: 1 }}>
                                          {renderAvailableJobAccordion(job, idx)}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                                
                                {!!finalTomorrowJobs.length && (
                                  <div className="mb-3">
                                    <h6 className="bg-dark text-warning text-center mb-2">Tomorrow</h6>
                                    <div className="d-flex flex-wrap gap-2">
                                      {finalTomorrowJobs.map((job, idx) => (
                                        <div key={job._id} style={{ minWidth: '300px', flex: '1 1 300px', maxWidth: '400px', position: 'relative', zIndex: 1 }}>
                                          {renderAvailableJobAccordion(job, idx)}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                                
                                {!!restOfWeekJobs.length && (
                                  <div className="mb-3">
                                    <h6 className="bg-dark text-warning text-center mb-2">Rest of week to Sunday</h6>
                                    <div className="d-flex flex-wrap gap-2">
                                      {restOfWeekJobs.map((job, idx) => (
                                        <div key={job._id} style={{ minWidth: '300px', flex: '1 1 300px', maxWidth: '400px', position: 'relative', zIndex: 1 }}>
                                          {renderAvailableJobAccordion(job, idx)}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                                
                                {!!finalNextWeekJobs.length && (
                                  <div className="mb-3">
                                    <h6 className="bg-dark text-warning text-center mb-2">Next Week From Monday({startOfNextWeek.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' })})</h6>
                                    <div className="d-flex flex-wrap gap-2">
                                      {finalNextWeekJobs.map((job, idx) => (
                                        <div key={job._id} style={{ minWidth: '300px', flex: '1 1 300px', maxWidth: '400px', position: 'relative', zIndex: 1 }}>
                                          {renderAvailableJobAccordion(job, idx)}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                                
                                {!!futureJobs.length && (
                                  <div className="mb-3">
                                    <h6 className="bg-dark text-warning text-center mb-2">Future Bookings</h6>
                                    <div className="d-flex flex-wrap gap-2">
                                      {futureJobs.map((job, idx) => (
                                        <div key={job._id} style={{ minWidth: '300px', flex: '1 1 300px', maxWidth: '400px', position: 'relative', zIndex: 1 }}>
                                          {renderAvailableJobAccordion(job, idx)}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })()}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )}

              {/* Cars Available Section */}
              <Row className="mb-3">
                <Col>
                  <h4 className="text-primary mb-3">🚗 Cars Available</h4>
                </Col>
              </Row>

              {/* Driver Columns */}
              <Row>
                {drivers && drivers.length > 0 ? (
                  drivers.map(renderDriverColumn)
                ) : (
                  <Col>
                    <Card className="border-info">
                      <Card.Header className="bg-info text-white">
                        <h5 className="mb-0">No Drivers Available</h5>
                      </Card.Header>
                      <Card.Body className="text-center">
                        <p className="mb-3">
                          No drivers are currently assigned to your dispatch fleet.
                        </p>
                        
                        {diagnostics && (
                          <div className="mb-4">
                            <h6>System Status:</h6>
                            <div className="row text-start">
                              <div className="col-md-3">
                                <div className="border rounded p-2 mb-2">
                                  <strong>Total Professional Drivers:</strong><br />
                                  <span className="text-primary">{diagnostics.totalProfessionalDrivers}</span>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="border rounded p-2 mb-2">
                                  <strong>With Dispatch Access:</strong><br />
                                  <span className="text-warning">{diagnostics.driversWithDispatchAccess}</span>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="border rounded p-2 mb-2">
                                  <strong>With Your Email:</strong><br />
                                  <span className="text-info">{diagnostics.driversWithDispatcherEmail}</span>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="border rounded p-2 mb-2">
                                  <strong>Manually Assigned:</strong><br />
                                  <span className="text-success">{diagnostics.driversAssignedToThisDispatcher}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        
                        <div className="alert alert-info">
                          <strong>To get drivers showing here:</strong>
                          <ol className="text-start mt-2">
                            <li>Drivers must have "Professional" role</li>
                            <li>Drivers must enable "Allow Dispatch Module access" in their profile</li>
                            <li><strong>Drivers must enter your email ({diagnostics.currentDispatcherEmail}) in their "Dispatcher Email" field</strong></li>
                            <li>OR Admin can manually assign drivers via "Dispatcher Management"</li>
                          </ol>
                          <div className="mt-3">
                            <Alert variant="success" className="text-start">
                              <strong>Automatic Linking:</strong>
                              <ul className="mb-0 mt-2">
                                <li>Drivers who enter your email in their profile will automatically appear here</li>
                                <li>No manual assignment needed - it's automatic!</li>
                                <li>Tell drivers to add "{diagnostics.currentDispatcherEmail}" to their Dispatcher Email field</li>
                              </ul>
                            </Alert>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                )}
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Edit Job Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Job</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Customer Name *</Form.Label>
                  <Form.Control
                    type="text"
                    value={editForm.customerName}
                    onChange={(e) => setEditForm(prev => ({ ...prev, customerName: e.target.value }))}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Phone *</Form.Label>
                  <Form.Control
                    type="tel"
                    value={editForm.phone}
                    onChange={(e) => setEditForm(prev => ({ ...prev, phone: e.target.value }))}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>From *</Form.Label>
                  <Form.Control
                    type="text"
                    value={editForm.from}
                    onChange={(e) => setEditForm(prev => ({ ...prev, from: e.target.value }))}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>To *</Form.Label>
                  <Form.Control
                    type="text"
                    value={editForm.to}
                    onChange={(e) => setEditForm(prev => ({ ...prev, to: e.target.value }))}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Date & Time *</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    value={editForm.dateTime}
                    onChange={(e) => setEditForm(prev => ({ ...prev, dateTime: e.target.value }))}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Passengers</Form.Label>
                  <Form.Control
                    type="number"
                    min="1"
                    value={editForm.passengers}
                    onChange={(e) => setEditForm(prev => ({ ...prev, passengers: parseInt(e.target.value) || 1 }))}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={editForm.notes}
                onChange={(e) => setEditForm(prev => ({ ...prev, notes: e.target.value }))}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveEdit} disabled={saving}>
            {saving ? 'Saving...' : 'Save Changes'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Create Job Modal - Same as Add to Diary */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} size="lg">
        <Form onSubmit={handleSaveCreate}>
          <Modal.Header closeButton className="sticky-top bg-white border-bottom">
            <Modal.Title>Add to Diary</Modal.Title>
            <Button type="submit" variant="success" disabled={saving} className="ms-auto">
              {saving ? 'Saving…' : 'Save & Accept'}
            </Button>
          </Modal.Header>
          <Modal.Body className="overflow-auto" style={{ maxHeight: '70vh' }}>
            {/* Date & Time Section */}
            <div className="border-bottom pb-2 mb-2">
              <h6 className="text-muted mb-2">📅 Journey Date</h6>
              <Row className="g-2">
                <Col xs={4}>
                  <Form.Label className="small mb-1">Month</Form.Label>
                  <Form.Control
                    type="text"
                    value={createForm.dateTime && createForm.dateTime instanceof Date ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][createForm.dateTime.getMonth()] : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][new Date().getMonth()]}
                    onClick={() => setShowCreateMonthModal(true)}
                    readOnly
                    size="sm"
                    placeholder="Click to select month"
                    style={{ cursor: 'pointer' }}
                  />
                </Col>
                <Col xs={4}>
                  <Form.Label className="small mb-1">Date</Form.Label>
                  <Form.Control
                    type="text"
                    value={createForm.dateTime && createForm.dateTime instanceof Date ? createForm.dateTime.getDate() : new Date().getDate()}
                    onClick={() => setShowDateModal(true)}
                    readOnly
                    size="sm"
                    placeholder="Click to select date"
                    style={{ cursor: 'pointer' }}
                  />
                </Col>
                <Col xs={4}>
                  <Form.Label className="small mb-1">Year</Form.Label>
                  <Form.Control
                    type="text"
                    value={createForm.dateTime && createForm.dateTime instanceof Date ? createForm.dateTime.getFullYear() : new Date().getFullYear()}
                    onClick={() => setShowCreateYearModal(true)}
                    readOnly
                    size="sm"
                    placeholder="Click to select year"
                    style={{ cursor: 'pointer' }}
                  />
                </Col>
              </Row>
              <Row className="g-2 mt-0">
                <Col xs={4}>
                  <Form.Label className="small mb-1">Hour</Form.Label>
                  <Form.Control
                    type="text"
                    value={createForm.dateTime && createForm.dateTime instanceof Date ? (createForm.dateTime.getHours() % 12 || 12) : (new Date().getHours() % 12 || 12)}
                    onClick={() => setShowCreateHourModal(true)}
                    readOnly
                    size="sm"
                    placeholder="Click to select hour"
                    style={{ cursor: 'pointer' }}
                  />
                </Col>
                <Col xs={4}>
                  <Form.Label className="small mb-1">Minute</Form.Label>
                  <Form.Control
                    type="text"
                    value={createForm.dateTime && createForm.dateTime instanceof Date ? Math.floor(createForm.dateTime.getMinutes() / 5) * 5 : Math.floor(new Date().getMinutes() / 5) * 5}
                    onClick={() => setShowCreateMinuteModal(true)}
                    readOnly
                    size="sm"
                    placeholder="Click to select minute"
                    style={{ cursor: 'pointer' }}
                  />
                </Col>
                <Col xs={4}>
                  <Form.Label className="small mb-1">AM/PM</Form.Label>
                  <Form.Control
                    type="text"
                    value={createForm.dateTime && createForm.dateTime instanceof Date ? (createForm.dateTime.getHours() < 12 ? 'AM' : 'PM') : (new Date().getHours() < 12 ? 'AM' : 'PM')}
                    onClick={() => {
                      const newDate = new Date(createForm.dateTime || new Date());
                      const currentHour = newDate.getHours();
                      if (currentHour >= 12) {
                        newDate.setHours(currentHour - 12);
                      } else {
                        newDate.setHours(currentHour + 12);
                      }
                      setCreateForm(prev => ({ ...prev, dateTime: newDate }));
                    }}
                    readOnly
                    size="sm"
                    placeholder="Click to toggle AM/PM"
                    style={{ 
                      cursor: 'pointer',
                      fontSize: '1.2rem',
                      fontWeight: 'bold',
                      textAlign: 'center'
                    }}
                  />
                </Col>
              </Row>
            </div>

            {/* Wait and Return Section */}
            <div className="border-bottom pb-2 mb-2">
              <h6 className="text-muted mb-2">⏰ Wait & Return</h6>
              <Row className="g-2">
                <Col xs={12}>
                  <Form.Check
                    type="checkbox"
                    label="Wait & Return"
                    name="waitAndReturn"
                    checked={createForm.waitAndReturn || false}
                    onChange={handleCreateFormChange}
                    className="mb-2"
                  />
                </Col>
                {createForm.waitAndReturn && (
                  <Col xs={12} sm={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="small">Expected Return Time (hours)</Form.Label>
                      <Form.Control
                        type="number"
                        name="waitHours"
                        min="0.5"
                        max="24"
                        step="0.5"
                        value={createForm.waitHours || ''}
                        onChange={handleCreateFormChange}
                        placeholder="4.5"
                        size="sm"
                      />
                      <Form.Text className="text-muted small">
                        {createForm.waitHours && createForm.dateTime && createForm.dateTime instanceof Date ? 
                          `Return time: ${calculateReturnTime(createForm.dateTime, createForm.waitHours)}` : 
                          'Enter hours to wait before return'
                        }
                      </Form.Text>
                    </Form.Group>
                  </Col>
                )}
              </Row>
            </div>

            {/* Customer Information Section */}
            <div className="border-bottom pb-2 mb-2">
              <h6 className="text-muted mb-2">👤 Customer Information</h6>
              <Row className="g-2">
                <Col xs={12} sm={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="small mb-1">Name</Form.Label>
                    <Form.Control
                      name="customerName" type="text"
                      value={createForm.customerName}
                      onChange={handleCreateFormChange}
                      placeholder="Enter customer name"
                      required
                      size="sm"
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="small mb-1">Email</Form.Label>
                    <Form.Control
                      name="customerEmail" type="email"
                      value={createForm.customerEmail}
                      onChange={handleCreateFormChange}
                      required
                      size="sm"
                    />
                  </Form.Group>
                </Col>
                <Col xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      type="tel"
                      name="customerPhone"
                      value={createForm.customerPhone}
                      onChange={handleCreateFormChange}
                      placeholder="Enter phone number"
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>

            {/* Journey Information Section */}
            <div className="border-bottom pb-2 mb-2">
              <h6 className="text-muted mb-2">🚗 Journey Details</h6>
              <Row className="g-2">
                <Col xs={12} sm={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="small">From</Form.Label>
                    <Form.Control
                      name="from" type="text"
                      value={createForm.from}
                      onChange={handleCreateFormChange}
                      required
                      size="sm"
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="small">To</Form.Label>
                    <Form.Control
                      name="to" type="text"
                      value={createForm.to}
                      onChange={handleCreateFormChange}
                      required
                      size="sm"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="g-2">
                <Col xs={12} sm={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="small">Passengers</Form.Label>
                    <Form.Control
                      name="passengers" type="number" min={1}
                      value={createForm.passengers||''}
                      onChange={handleCreateFormChange}
                      required
                      size="sm"
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Group className="mb-2">
                    <Form.Label className="small">Fare (£)</Form.Label>
                    <Form.Control
                      name="fareAmount"
                      type="text"
                      placeholder="e.g. £12.50"
                      value={createForm.fareAmount || ''}
                      onChange={handleCreateFormChange}
                      size="sm"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="g-2">
                <Col xs={12} sm={6}>
                  <Form.Check
                    type="checkbox" label="🐕 Dog/Pet"
                    name="dog"
                    checked={createForm.dog || false}
                    onChange={handleCreateFormChange}
                    className="mb-1"
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Check
                    type="checkbox" label="♿ Disabled"
                    name="disabled"
                    checked={createForm.disabled || false}
                    onChange={handleCreateFormChange}
                    className="mb-1"
                  />
                </Col>
              </Row>
              <Row className="g-2">
                <Col xs={12} sm={6}>
                  <Form.Check
                    type="checkbox" label="🔄 Return Trip"
                    name="returnTrip"
                    checked={createForm.returnTrip || false}
                    onChange={handleCreateFormChange}
                    className="mb-1"
                  />
                </Col>
              </Row>
            </div>

            {/* Notes Section */}
            <div>
              <h6 className="text-muted mb-2">📝 Notes</h6>
              <Form.Group className="mb-2">
                <Form.Label className="small mb-1">Notes</Form.Label>
                <Form.Control
                  as="textarea"
                  rows="2"
                  name="notes"
                  value={createForm.notes || ''}
                  onChange={handleCreateFormChange}
                  maxLength={50}
                  placeholder="Any additional notes..."
                  size="sm"
                />
                <Form.Text className="text-muted small">
                  {createForm.notes ? createForm.notes.length : 0}/50 characters
                </Form.Text>
              </Form.Group>
            </div>

            {/* Driver Selection */}
            <div className="border-top pt-2 mt-2">
              <h6 className="text-muted mb-2">🚗 Driver Assignment</h6>
              <Form.Group className="mb-2">
                <Form.Label className="small">Select Driver (Optional)</Form.Label>
                <Form.Select
                  name="driverId"
                  value={createForm.driverId}
                  onChange={handleCreateFormChange}
                  size="sm"
                >
                  <option value="">Create as available job (no driver assigned)</option>
                  {drivers && drivers.map(driver => (
                    <option key={driver._id} value={driver._id}>
                      {driver.companyName || driver.name} - {driver.email}
                    </option>
                  ))}
                </Form.Select>
                <Form.Text className="text-muted small">
                  If no driver is selected, the job will appear in "Available Jobs for Dispatch" section.
                </Form.Text>
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCreateModal(false)}>Cancel</Button>
            <Button type="submit" variant="success" disabled={saving} className="ms-auto">
              {saving ? 'Saving…' : 'Save & Accept'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Dispatch Job Modal */}
      <Modal show={showDispatchModal} onHide={() => setShowDispatchModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Dispatch Job</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedJob && (
            <div className="mb-3 p-3 border rounded bg-light">
              <h6>Job Details:</h6>
              <p><strong>Customer:</strong> {selectedJob.customerName?.split(' ')[0] || selectedJob.customerName}</p>
              <p><strong>From:</strong> {selectedJob.from}</p>
              <p><strong>To:</strong> {selectedJob.to}</p>
              <p><strong>Date/Time:</strong> {selectedJob.dateTime ? new Date(selectedJob.dateTime).toLocaleString() : 'No time set'}</p>
              <p><strong>Phone:</strong> {selectedJob.customerPhone}</p>
              {selectedJob.notes && <p><strong>Notes:</strong> {selectedJob.notes}</p>}
            </div>
          )}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Select Driver *</Form.Label>
              <Form.Select
                value={dispatchForm.driverId}
                onChange={(e) => setDispatchForm(prev => ({ ...prev, driverId: e.target.value }))}
                required
              >
                <option value="">Choose a driver...</option>
                {drivers && drivers.map(driver => (
                  <option key={driver._id} value={driver._id}>
                    {driver.companyName || driver.name} - {driver.email}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Dispatch Note (optional)</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={dispatchForm.dispatchNote}
                onChange={(e) => setDispatchForm(prev => ({ ...prev, dispatchNote: e.target.value }))}
                placeholder="Add any notes for the driver..."
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDispatchModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleSaveDispatch} disabled={saving}>
            {saving ? 'Dispatching...' : 'Dispatch Job'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Reassign Job Modal */}
      <Modal show={showReassignModal} onHide={() => setShowReassignModal(null)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Reassign Job
            {showReassignModal?.job?.reassignedBy && showReassignModal?.job?.acceptedBy?.companyName && (
              <span className="text-muted ms-2">({showReassignModal.job.acceptedBy.companyName})</span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showReassignModal && (
            <div className="mb-3 p-3 border rounded bg-light">
              <h6>Job Details:</h6>
              <p><strong>Customer:</strong> {showReassignModal.job.customerName?.split(' ')[0] || showReassignModal.job.customerName}</p>
              <p><strong>From:</strong> {showReassignModal.job.from}</p>
              <p><strong>To:</strong> {showReassignModal.job.to}</p>
              <p><strong>Date/Time:</strong> {showReassignModal.job.dateTime ? new Date(showReassignModal.job.dateTime).toLocaleString() : 'No time set'}</p>
              <p><strong>Phone:</strong> {showReassignModal.job.customerPhone}</p>
              {showReassignModal.job.notes && <p><strong>Notes:</strong> {showReassignModal.job.notes}</p>}
            </div>
          )}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Select New Driver *</Form.Label>
              <Form.Select
                value={selectedDriver || ''}
                onChange={(e) => setSelectedDriver(e.target.value)}
                required
              >
                <option value="">Choose a driver...</option>
                {drivers && drivers.map(driver => (
                  <option key={driver._id} value={driver._id}>
                    {driver.companyName || driver.name} - {driver.email}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowReassignModal(null)}>
            Cancel
          </Button>
          <Button 
            variant="warning" 
            onClick={() => {
              try {
                console.log('Reassign button clicked:', {
                  showReassignModal,
                  selectedDriver,
                  jobId: showReassignModal?.job?._id,
                  fromDriverId: showReassignModal?.fromDriverId
                });
                
                if (showReassignModal && showReassignModal.job && showReassignModal.job._id && selectedDriver) {
                  handleReassignJob(showReassignModal.job._id, showReassignModal.fromDriverId, selectedDriver);
                  setShowReassignModal(null);
                  setSelectedDriver(null);
                } else {
                  console.error('Missing required data for reassignment:', {
                    showReassignModal: !!showReassignModal,
                    job: !!showReassignModal?.job,
                    jobId: !!showReassignModal?.job?._id,
                    selectedDriver: !!selectedDriver
                  });
                  toast.error('Missing required data for job reassignment');
                }
              } catch (error) {
                console.error('Error in reassign button click:', error);
                toast.error('Error reassigning job: ' + error.message);
              }
            }} 
            disabled={saving || !selectedDriver || !showReassignModal?.job?._id}
          >
            {saving ? 'Reassigning...' : 'Reassign Job'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Date Picker Modals (same as Add to Diary) */}
      {/* Date Picker Modal */}
      <Modal show={showDateModal} onHide={() => setShowDateModal(false)} size="sm" dialogClassName="modal-sm">
        <Modal.Header closeButton className="py-2">
          <Modal.Title className="fs-6 text-center w-100">Select Date</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-2">
          <div className="d-flex flex-wrap gap-2">
            {Array.from({ length: 31 }, (_, i) => i + 1).map((date) => (
              <div key={date} className="col-2 p-1">
                <div
                  className="btn btn-outline-primary btn-sm w-100"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    const currentDate = createForm.dateTime && createForm.dateTime instanceof Date ? createForm.dateTime : new Date();
                    const newDate = new Date(currentDate);
                    newDate.setDate(date);
                    setCreateForm(prev => ({ ...prev, dateTime: newDate }));
                    setShowDateModal(false);
                  }}
                >
                  {date}
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer className="py-2">
          <Button variant="secondary" size="sm" onClick={() => setShowDateModal(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Month Picker Modal */}
      <Modal show={showCreateMonthModal} onHide={() => setShowCreateMonthModal(false)} size="sm" dialogClassName="modal-sm">
        <Modal.Header closeButton className="py-2">
          <Modal.Title className="fs-6 text-center w-100">Select Month</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-2">
          <div className="d-flex flex-wrap gap-2">
            {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map((month, index) => (
              <Button
                key={index}
                variant="outline-primary"
                size="sm"
                className="col-3 mb-2"
                onClick={() => {
                  const currentDate = createForm.dateTime && createForm.dateTime instanceof Date ? createForm.dateTime : new Date();
                  const newDate = new Date(currentDate);
                  newDate.setMonth(index);
                  setCreateForm(prev => ({ ...prev, dateTime: newDate }));
                  setShowCreateMonthModal(false);
                }}
              >
                {month}
              </Button>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer className="py-2">
          <Button variant="secondary" size="sm" onClick={() => setShowCreateMonthModal(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Year Picker Modal */}
      <Modal show={showCreateYearModal} onHide={() => setShowCreateYearModal(false)} size="sm" dialogClassName="modal-sm">
        <Modal.Header closeButton className="py-2">
          <Modal.Title className="fs-6 text-center w-100">Select Year</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-2">
          <div className="d-flex flex-wrap gap-2">
            {[2025, 2026, 2027].map((year) => (
              <Button
                key={year}
                variant="outline-primary"
                size="sm"
                className="col-4 mb-2"
                onClick={() => {
                  const currentDate = createForm.dateTime && createForm.dateTime instanceof Date ? createForm.dateTime : new Date();
                  const newDate = new Date(currentDate);
                  newDate.setFullYear(year);
                  setCreateForm(prev => ({ ...prev, dateTime: newDate }));
                  setShowCreateYearModal(false);
                }}
              >
                {year}
              </Button>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer className="py-2">
          <Button variant="secondary" size="sm" onClick={() => setShowCreateYearModal(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Hour Picker Modal */}
      <Modal show={showCreateHourModal} onHide={() => setShowCreateHourModal(false)} size="sm" dialogClassName="modal-sm">
        <Modal.Header closeButton className="py-2">
          <Modal.Title className="fs-6 text-center w-100">Select Time Required</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-2">
          <div className="d-flex">
            <div className="flex-grow-1">
              {/* Row 1: Hours 1-6 */}
              <div className="row mb-2 g-1">
                {[1, 2, 3, 4, 5, 6].map((hour) => (
                  <div key={hour} className="col-2">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="w-100"
                      onClick={() => {
                        const currentDate = createForm.dateTime && createForm.dateTime instanceof Date ? createForm.dateTime : new Date();
                        const newDate = new Date(currentDate);
                        const currentHour = newDate.getHours();
                        const isPM = currentHour >= 12;
                        newDate.setHours(isPM ? hour + 12 : hour);
                        setCreateForm(prev => ({ ...prev, dateTime: newDate }));
                        setShowCreateHourModal(false);
                      }}
                    >
                      {hour}
                    </Button>
                  </div>
                ))}
              </div>
              {/* Row 2: Hours 7-12 */}
              <div className="row mb-2 g-1">
                {[7, 8, 9, 10, 11, 12].map((hour) => (
                  <div key={hour} className="col-2">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="w-100"
                      onClick={() => {
                        const currentDate = createForm.dateTime && createForm.dateTime instanceof Date ? createForm.dateTime : new Date();
                        const newDate = new Date(currentDate);
                        const currentHour = newDate.getHours();
                        const isPM = currentHour >= 12;
                        if (hour === 12) {
                          newDate.setHours(isPM ? 12 : 0);
                        } else {
                          newDate.setHours(isPM ? hour + 12 : hour);
                        }
                        setCreateForm(prev => ({ ...prev, dateTime: newDate }));
                        setShowCreateHourModal(false);
                      }}
                    >
                      {hour}
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="py-2">
          <Button variant="secondary" size="sm" onClick={() => setShowCreateHourModal(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Minute Picker Modal */}
      <Modal show={showCreateMinuteModal} onHide={() => setShowCreateMinuteModal(false)} size="sm" dialogClassName="modal-sm">
        <Modal.Header closeButton className="py-2">
          <Modal.Title className="fs-6 text-center w-100">Select Minute</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-2">
          {/* Row 1: Minutes 00, 05, 10, 15, 20, 25 */}
          <div className="row mb-2 g-1">
            {[0, 5, 10, 15, 20, 25].map((minute) => (
              <div key={minute} className="col-2">
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="w-100"
                  onClick={() => {
                    const currentDate = createForm.dateTime && createForm.dateTime instanceof Date ? createForm.dateTime : new Date();
                    const newDate = new Date(currentDate);
                    newDate.setMinutes(minute);
                    setCreateForm(prev => ({ ...prev, dateTime: newDate }));
                    setShowCreateMinuteModal(false);
                  }}
                >
                  {minute.toString().padStart(2, '0')}
                </Button>
              </div>
            ))}
          </div>
          {/* Row 2: Minutes 30, 35, 40, 45, 50, 55 */}
          <div className="row mb-2 g-1">
            {[30, 35, 40, 45, 50, 55].map((minute) => (
              <div key={minute} className="col-2">
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="w-100"
                  onClick={() => {
                    const currentDate = createForm.dateTime && createForm.dateTime instanceof Date ? createForm.dateTime : new Date();
                    const newDate = new Date(currentDate);
                    newDate.setMinutes(minute);
                    setCreateForm(prev => ({ ...prev, dateTime: newDate }));
                    setShowCreateMinuteModal(false);
                  }}
                >
                  {minute.toString().padStart(2, '0')}
                </Button>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer className="py-2">
          <Button variant="secondary" size="sm" onClick={() => setShowCreateMinuteModal(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer position="top-right" />
    </Container>
  );
};

export default DispatchModule;
